// Copyright (C) 2023 Cochise Ruhulessin
// 
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
  IonButton,
  IonButtons,
  IonFooter,
  IonToolbar,
} from '@ionic/react'
import { CurrentUser } from '../services'


interface ContainerProps {
  disableBackButton?: boolean
  nav: HTMLIonNavElement
  user: CurrentUser
}


const FooterControl: React.FC<ContainerProps> = ({
  disableBackButton,
  nav,
  user
}) => {
  if (!nav) { return null }
  return (
    <IonFooter>
      <IonToolbar>
        <IonButtons slot="end">
          <IonButton
            color="primary"
            fill="clear"
          >
            {user.claims.email}
          </IonButton>
        </IonButtons>
        <IonButtons slot="start">
          <IonButton
            color="danger"
            fill="clear"
            onClick={() => {
              nav.popToRoot()
            }}
            style={{visibility: (!!disableBackButton) ? "hidden" : "visible"}}
          >
            Terug naar het begin
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonFooter>
  )
}

export  { FooterControl }
